import { useCallback, useEffect, useState } from 'react';

import config from '../../../config';
import { decrypt } from '../../../utils/encryption';
import { type InquiryForm } from '../../../models/Inquiry/Inquiry';

import classes from './InquiryPreview.module.css';
import InquiryPreviewItem from './InquiryPreviewItem';
import InquiryPreviewConfirm from './InquiryPreviewConfirm';
import Captcha from '../components/Captcha';
import { generateRandomString } from '../../../utils';
import '../components/InquiryForm.css';

export default function InquiryPreview() {
  const [data, setData] = useState<InquiryForm>();
  const [random, setRandom] = useState('');
  const [isConfirm, setIsConfirm] = useState(false);

  const generateCaptcha = useCallback(
    () => {
      setRandom(() => generateRandomString(5));
    },
    [],
  );

  useEffect(() => {
    generateCaptcha();
  }, [generateCaptcha]);

  useEffect(() => {
    try {
      const encrypted = window.sessionStorage.getItem(config.preview.storageKey);
      const dataString = encrypted && decrypt(encrypted);
      const json = dataString && JSON.parse(dataString);

      if (json) setData(json);
    } catch (error) {
      console.warn(error);
    }
  }, []);

  const handleOpenConfirm = () => {
    setIsConfirm(true);
  };

  const handleCloseConfirm = () => {
    setIsConfirm(false);
  };

  const handleClose = () => {
    window.close();
  };

  return (
    <main
      className="content"
      style={{
        maxHeight: '100vh',
        overflowY: 'auto',
      }}
    >
      <div className="container-fluid p-0">
        {isConfirm && data ? (
          <InquiryPreviewConfirm
            data={data}
            formValues={{}}
            onBack={handleCloseConfirm}
          />
        ) : (
          <>
            {/* Header */}
            <div className="card">
              <div className="card-body">
                <div className="card-title fw-bold fs-4 font-sm mb-1 notranslate" translate="no">
                  {data?.name}
                </div>
                <p className="card-text notranslate" translate="no" style={{ whiteSpace: 'pre-wrap' }}>
                  {data?.description}
                </p>
              </div>
            </div>

            {/* Inquiry Items */}
            <div className="card">
              {data?.definition && data.definition.length > 0 && (
                <div className="card-body">

                  {data.definition.map((item) => (
                    <InquiryPreviewItem
                      key={item.uuid}
                      data={item}
                    />
                  ))}

                  {data.captcha && (
                    <div className="d-flex justify-content-center align-items-center gap-2 mt-4">
                      <Captcha
                        code={random}
                        generate={generateCaptcha}
                      />
                    </div>
                  )}
                </div>
              )}

              {/* Action Buttons */}
              <div className="card-footer border-top bg-white text-center">
                <button type="button" className="btn btn-outline-secondary" onClick={handleClose}>Close</button>
                {data?.confirm_page ? (
                  <button
                    type="button"
                    className="btn btn-primary mx-2"
                    onClick={handleOpenConfirm}
                    disabled={!data}
                  >
                    <span className="mx-2">Confirm</span>
                  </button>
                ) : (
                  <button type="button" className="btn btn-primary mx-2" disabled>
                    <span className="mx-2">Submit</span>
                  </button>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </main>
  );
}
